import { z } from "zod";

export const contactFormSchema = z.object({
  name: z.string()
    .trim()
    .min(1, "Name is required")
    .max(100, "Name must be less than 100 characters"),
  email: z.string()
    .trim()
    .email("Invalid email address")
    .max(255, "Email must be less than 255 characters"),
  subject: z.string()
    .trim()
    .min(1, "Subject is required")
    .max(200, "Subject must be less than 200 characters"),
  message: z.string()
    .trim()
    .min(1, "Message is required")
    .max(5000, "Message must be less than 5000 characters"),
});

export const newsletterSchema = z.object({
  email: z.string()
    .trim()
    .email("Invalid email address")
    .max(255, "Email must be less than 255 characters"),
});

export const urlSchema = z.string()
  .trim()
  .url("Invalid URL format")
  .max(2048, "URL too long")
  .refine((url) => {
    try {
      const parsed = new URL(url);
      // Block private IPs and localhost
      const blockedHosts = [
        'localhost', '127.0.0.1', '[::1]',
        '169.254.169.254', // AWS metadata
      ];
      
      if (blockedHosts.some(host => parsed.hostname.includes(host))) {
        return false;
      }
      
      // Block private IP ranges
      const ipv4Regex = /^(\d{1,3})\.(\d{1,3})\.(\d{1,3})\.(\d{1,3})$/;
      const match = parsed.hostname.match(ipv4Regex);
      if (match) {
        const [, a, b] = match.map(Number);
        // Block 10.x.x.x, 172.16-31.x.x, 192.168.x.x
        if (a === 10 || (a === 172 && b >= 16 && b <= 31) || (a === 192 && b === 168)) {
          return false;
        }
      }
      
      // Only allow http and https
      return ['http:', 'https:'].includes(parsed.protocol);
    } catch {
      return false;
    }
  }, "Invalid or blocked URL");

export type ContactFormData = z.infer<typeof contactFormSchema>;
export type NewsletterData = z.infer<typeof newsletterSchema>;
